import * as React from "react";
import styled from "@emotion/styled";
import breakpoint from "@/utils/breakpoint";

type ArticleProps = {
  children: (React.ReactElement<Parameters<typeof Block>> | React.ReactElement<Parameters<typeof Header>> | boolean)[];
} & React.HTMLAttributes<HTMLDivElement>;

type ArticleHeaderProps = Record<string, any> & React.HTMLAttributes<HTMLHeadElement>;

type ArticleBlockProps = Record<string, any> & React.HTMLAttributes<HTMLDivElement>;

const Wrapper = styled.div`
  width: 100%;
`;

const Header = styled.h2`
  font-size: 20px;
  font-weight: normal;
  margin: 0 0 15px 0;
  ${breakpoint.lessThan("sm")`
    margin: 0 0 10px 0;
  `}
`;

const Block = styled.div`
  width: 100%;
  margin: 0 0 30px 0;
  border: 1px solid #ccc;
  border-bottom: none;

  &.disable-span {
    span {
      display: none;
    }
  }

  &.border-none {
    border: none;
  }
  &.bgWhite {
    background-color: white;
    padding: 0 15px;
  }
  &.fixed-width-70 {
    width: 70%;
    margin: auto;
  }
  &.fixed-width-74 {
    width: 74%;
    margin: auto;
  }
  &.fixed-width-59 {
    width: 59%;
    margin: auto;
  }
  &.fixed-width-55 {
    width: 55%;
    margin: auto;
  }
  &.pt-50 {
    padding-top: 50px;
  }
  &.pt-28 {
    padding-top: 50px;
  }
  ${breakpoint.lessThan("sm")`
  &.border-none {
    border: none;
  }
  &.fixed-width-70 {
    width: 100%;
    margin: auto;
  }
  &.fixed-width-55 {
    width: 100%;
    margin: auto;
  }
  &.fixed-width-74 {
    width: 100%;
    margin: auto;
  }
  &.fixed-width-59 {
    width: 100%;
    margin: auto;
  }
  &.plr {
    padding 0px 15px;
    margin-bottom: 40px;
  }
  `}
`;

const Article = ({ children, ...props }: ArticleProps) => <Wrapper {...props}>{children}</Wrapper>;

Article.Header = ({ children, ...props }: ArticleHeaderProps) => <Header {...props}>{children}</Header>;

Article.Block = ({ children, ...props }: ArticleBlockProps) => <Block {...props}>{children}</Block>;

export default Article;
